import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { Link, NavLink } from "react-router-dom";
import FilterNotFound from "../../HomeWork/Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../../SubjectIcon";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";
import PublishedQListPreRead from "./PublishedQListPreRead";

export default function Pending({ setHomeMain, filter }) {
  const [pendingCard, setPendingCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [noContentClick, setNoContentClick] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const pendingBox = async () => {
      try {
        let response = await axios.get(
          `/homework/preRead/filterByStudentId/${currentUser?.id}/pending?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
          `${filter?.date
            ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
            : ``
          }` +
          `${filter?.time ? `&time=${filter?.time}` : ``}` +
          `${filter?.subjectId?.length !== 0
            ? `&subjectId=${filter?.subjectId}`
            : ``
          }`
        );

        response && setPendingCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    pendingBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };


  return (
    <div>
      {pendingCard && pendingCard.length > 0 ? (
        <div className="d-flex justify-content-start gap-3 flex-wrap">
          {pendingCard?.map((card, index) => (
            <div key={card.id} className="link"
              onClick={() => {
                setIsPopupOpen(true);
                setSelectedId(card?.id);
              }}
            >
              <div
                key={index}
                // className="summarySubBoxContainerHW"
                className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                style={{
                  borderTop: `8px solid #${card?.subject_id?.subject_color}`,
                }}
              >
                <div
                  className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"

                >
                  <div>
                    <div className="subboxSubjectName">
                      {card?.subject_id?.name}
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${SubjectIcon?.find(
                        (i) => i.subjectName === card?.subject_id?.name
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-start">
                  <div className="d-flex align-items-center">
                    {/* <img src="/HwImg/FileIconPreRead.png" alt=""></img> */}
                  </div>
                  <div>
                    {/* <div className="subjectPreRead">{card?.subject_id?.name}</div> */}
                    <div className="SubChapName">{
                      <Tooltip
                        title={card?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div className="flex">
                          <BookText size={16} className="me-2 mt-1 text-dark" />
                          {shortenParagraph(card?.name, 35)}
                        </div>
                      </Tooltip>}</div>
                    <div className="PreReadDeadline flex mt-2">
                      <CalendarDays size={16} className="me-2 text-dark" />
                      <div> Deadline: &nbsp;</div>{timeHelper(card?.deadline)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {isPopupOpen && selectedId && (
            <PublishedQListPreRead
              publishPre_id={selectedId}
              setIsPopupOpen={setIsPopupOpen}
            />
          )}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (<span>PreRead Not Found</span>
        // : noContentClick ? (
        //   <span>PreRead Not Found</span>
        // ) : (
        //   <FilterNotFound setNoContentClick={setNoContentClick} />
      )
      }
    </div >
  );
}
